import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { LinkElement } from '@els/els-react--link-element';

function ImportFileModalFooter({ onImport, uploadedFile, onClearImportFile }) {
  return (
    <div className="import-file-modal__footer-container">
      <LinkElement
        data-e2e="import-file-learn-more"
        href="https://service.elsevier.com/app/answers/detail/a_id/26151/supporthub/reaxys/kw/import/"
        isExternal
        className="u-els-font-family-base u-els-padding-top"
        iconSprite="UpRight"
        iconRight>
        Learn about importing files
      </LinkElement>
      <div className="import-file-modal__footer u-els-padding-top">
        <ButtonWithIcon
          data-e2e="import-file-clear"
          sprite="Trash"
          type="link"
          iconRight
          size="small"
          className="u-els-padding-right-1o2 u-els-margin-right-1o2"
          disabled={!uploadedFile}
          aria-label="Clear Imported Query"
          onClick={onClearImportFile}>
          Clear
        </ButtonWithIcon>
        <Button
          data-e2e="import-file-import"
          size="small"
          disabled={!uploadedFile}
          id="import-file-modal-open"
          onClick={onImport}
          aria-label="Open Imported Query">
          Import
        </Button>
      </div>
    </div>
  );
}

ImportFileModalFooter.propTypes = {
  onImport: PropTypes.func.isRequired,
  onClearImportFile: PropTypes.func.isRequired,
  uploadedFile: PropTypes.object,
};

export default ImportFileModalFooter;
